import { useState } from "react";
import { Field, inputShell } from "../Field";

export const MIN_PASSWORD = 12;

/** The checks the server makes, shown before submitting so the admin isn't bounced for a rule they couldn't see. */
export function passwordProblem(password: string, email: string): string | null {
  if (password.length < MIN_PASSWORD) return `Use at least ${MIN_PASSWORD} characters.`;
  const lower = password.toLowerCase();
  const local = email.split("@")[0]?.toLowerCase() ?? "";
  if ((local.length >= 4 && lower.includes(local)) || /password|gateway/.test(lower))
    return "Avoid your email, 'password' or 'gateway'.";
  if (new Set(password).size < 5) return "Use a less repetitive password.";
  return null;
}

/** New password + confirm, with a show toggle. A long passphrase ("four random words") is the suggestion. */
export function NewPasswordFields({
  email,
  value,
  confirm,
  onChange,
  onConfirm,
}: {
  email: string;
  value: string;
  confirm: string;
  onChange: (value: string) => void;
  onConfirm: (value: string) => void;
}) {
  const [show, setShow] = useState(false);
  const problem = value ? passwordProblem(value, email) : null;
  const mismatch = confirm && confirm !== value ? "The two passwords don't match." : null;
  return (
    <>
      <Field
        label="New password"
        htmlFor="new-password"
        error={problem}
        hint={`At least ${MIN_PASSWORD} characters. A short sentence or four random words works well.`}
      >
        <input
          id="new-password"
          type={show ? "text" : "password"}
          autoComplete="new-password"
          className={inputShell}
          value={value}
          aria-describedby="new-password-error"
          onChange={(event) => onChange(event.target.value)}
        />
      </Field>
      <Field label="Confirm new password" htmlFor="confirm-password" error={mismatch}>
        <input
          id="confirm-password"
          type={show ? "text" : "password"}
          autoComplete="new-password"
          className={inputShell}
          value={confirm}
          aria-describedby="confirm-password-error"
          onChange={(event) => onConfirm(event.target.value)}
        />
      </Field>
      <label className="mb-4 flex items-center gap-2 text-[13.5px] text-text-muted">
        <input type="checkbox" checked={show} onChange={() => setShow(!show)} />
        Show passwords
      </label>
    </>
  );
}

export const newPasswordReady = (value: string, confirm: string, email: string) =>
  Boolean(value) && value === confirm && !passwordProblem(value, email);
